import React, { useEffect, useState } from 'react';
import { LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
const CORRECT_PASSWORD = 'creditual2025'; // Cambiar esta contraseña según necesites
export function PitchPage() {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);
  // Verificar si ya está autenticado en sessionStorage
  useEffect(() => {
    const auth = sessionStorage.getItem('pitch-authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('pitch-authenticated', 'true');
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };
  // Pantalla de login
  if (!isAuthenticated) {
    return <div className="min-h-screen bg-gradient-to-br from-[#0A1628] via-[#1a2942] to-[#0A1628] flex items-center justify-center p-4" data-id="element-464">
        <div className="w-full max-w-md" data-id="element-465">
          {/* Logo */}
          <div className="text-center mb-8" data-id="element-466">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#2B5FD9] mb-4" data-id="element-467">
              <LockIcon className="h-8 w-8 text-white" data-id="element-468" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2" data-id="element-469">
              Creditual Pitch
            </h1>
            <p className="text-sm text-gray-400" data-id="element-470">Contenido protegido</p>
          </div>

          {/* Form */}
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 shadow-2xl" data-id="element-471">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-472">
              <div data-id="element-473">
                <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-474">
                  Contraseña de acceso
                </label>
                <div className="relative" data-id="element-475">
                  <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                  setPassword(e.target.value);
                  setError(false);
                }} className={`w-full px-4 py-3 bg-white/10 border ${error ? 'border-red-500' : 'border-white/20'} rounded-xl text-white placeholder-gray-500 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all`} placeholder="Ingresa la contraseña" autoFocus data-id="element-476" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors" data-id="element-477">
                    {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-478" /> : <EyeIcon className="h-5 w-5" data-id="element-479" />}
                  </button>
                </div>
                {error && <p className="mt-2 text-sm text-red-400" data-id="element-480">
                    Contraseña incorrecta. Inténtalo de nuevo.
                  </p>}
              </div>

              <button type="submit" className="w-full px-6 py-3 bg-[#2B5FD9] text-white font-semibold rounded-xl hover:bg-[#1E4BB8] transition-colors shadow-lg hover:shadow-xl" data-id="element-481">
                Acceder
              </button>
            </form>
          </div>

          {/* Footer */}
          <p className="text-center text-xs text-gray-500 mt-6" data-id="element-482">
            Si no tienes acceso, contacta al equipo de Creditual
          </p>
        </div>
      </div>;
  }
  // Contenido del pitch (después de autenticarse)
  return <div className="min-h-screen bg-white" data-id="element-483">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-50" data-id="element-484">
        <div className="container mx-auto max-w-7xl px-6 py-4" data-id="element-485">
          <div className="flex items-center justify-between" data-id="element-486">
            <div className="flex items-center gap-3" data-id="element-487">
              <div className="w-10 h-10 rounded-xl bg-[#2B5FD9] flex items-center justify-center" data-id="element-488">
                <span className="text-white font-bold text-lg" data-id="element-489">C</span>
              </div>
              <div data-id="element-490">
                <h1 className="text-xl font-bold text-[#0A1628]" data-id="element-491">Creditual</h1>
                <p className="text-xs text-[#6B7280]" data-id="element-492">Pitch Deck</p>
              </div>
            </div>
            <button onClick={() => {
            sessionStorage.removeItem('pitch-authenticated');
            setIsAuthenticated(false);
            setPassword('');
          }} className="text-sm text-[#6B7280] hover:text-[#0A1628] transition-colors" data-id="element-493">
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      {/* Contenido del Pitch */}
      <div className="container mx-auto max-w-5xl px-6 py-12" data-id="element-494">
        {/* Slide 1: Problema */}
        <section className="mb-16" data-id="element-495">
          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 md:p-12 border border-red-100" data-id="element-496">
            <span className="inline-block px-3 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded-full mb-4" data-id="element-497">
              EL PROBLEMA
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-498">
              Obtener un crédito hipotecario en Chile es lento, confuso y
              frustrante
            </h2>
            <div className="space-y-4" data-id="element-499">
              <div className="flex items-start gap-3" data-id="element-500">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-501">
                  <span className="text-white font-bold" data-id="element-502">1</span>
                </div>
                <div data-id="element-503">
                  <h3 className="font-bold text-[#0A1628] mb-1" data-id="element-504">
                    Proceso lento (4-6 semanas)
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-505">
                    Los compradores esperan semanas para saber si califican,
                    perdiendo oportunidades.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-506">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-507">
                  <span className="text-white font-bold" data-id="element-508">2</span>
                </div>
                <div data-id="element-509">
                  <h3 className="font-bold text-[#0A1628] mb-1" data-id="element-510">
                    Falta de claridad
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-511">
                    No saben cuánto pueden pedir ni qué banco les conviene hasta
                    muy tarde en el proceso.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-512">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-513">
                  <span className="text-white font-bold" data-id="element-514">3</span>
                </div>
                <div data-id="element-515">
                  <h3 className="font-bold text-[#0A1628] mb-1" data-id="element-516">
                    Múltiples postulaciones
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-517">
                    Deben postular banco por banco, repitiendo el mismo proceso
                    una y otra vez.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 2: Solución */}
        <section className="mb-16" data-id="element-518">
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 border border-blue-100" data-id="element-519">
            <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full mb-4" data-id="element-520">
              LA SOLUCIÓN
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-521">
              Creditual: Tu mejor crédito hipotecario en días, no semanas
            </h2>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-522">
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-523">
                <div className="w-12 h-12 rounded-xl bg-[#2B5FD9] flex items-center justify-center mb-4" data-id="element-524">
                  <span className="text-white text-2xl font-bold" data-id="element-525">1</span>
                </div>
                <h3 className="font-bold text-[#0A1628] mb-2" data-id="element-526">
                  Un solo formulario
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-527">
                  Completa tus datos una vez y evalúa en múltiples bancos
                  simultáneamente.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-528">
                <div className="w-12 h-12 rounded-xl bg-[#2B5FD9] flex items-center justify-center mb-4" data-id="element-529">
                  <span className="text-white text-2xl font-bold" data-id="element-530">2</span>
                </div>
                <h3 className="font-bold text-[#0A1628] mb-2" data-id="element-531">
                  Resultados en 24-48h
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-532">
                  Sabes cuánto puedes pedir y qué bancos te aprueban en días.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-533">
                <div className="w-12 h-12 rounded-xl bg-[#2B5FD9] flex items-center justify-center mb-4" data-id="element-534">
                  <span className="text-white text-2xl font-bold" data-id="element-535">3</span>
                </div>
                <h3 className="font-bold text-[#0A1628] mb-2" data-id="element-536">
                  100% transparente
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-537">
                  Comparas tasas, plazos y condiciones para elegir tu mejor
                  opción.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 3: Mercado */}
        <section className="mb-16" data-id="element-538">
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 md:p-12 border border-green-100" data-id="element-539">
            <span className="inline-block px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full mb-4" data-id="element-540">
              OPORTUNIDAD DE MERCADO
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-541">
              Un mercado enorme y en crecimiento
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-542">
              <div data-id="element-543">
                <div className="mb-6" data-id="element-544">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-545">
                    $50B+
                  </p>
                  <p className="text-[#6B7280]" data-id="element-546">
                    Créditos hipotecarios colocados anualmente en Chile
                  </p>
                </div>
                <div className="mb-6" data-id="element-547">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-548">80K+</p>
                  <p className="text-[#6B7280]" data-id="element-549">
                    Operaciones de crédito hipotecario al año
                  </p>
                </div>
              </div>
              <div data-id="element-550">
                <div className="mb-6" data-id="element-551">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-552">15+</p>
                  <p className="text-[#6B7280]" data-id="element-553">
                    Instituciones financieras compitiendo por clientes
                  </p>
                </div>
                <div data-id="element-554">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-555">0</p>
                  <p className="text-[#6B7280]" data-id="element-556">
                    Plataformas digitales que comparen y gestionen todo el
                    proceso
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 4: Modelo de Negocio */}
        <section className="mb-16" data-id="element-557">
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 md:p-12 border border-purple-100" data-id="element-558">
            <span className="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-semibold rounded-full mb-4" data-id="element-559">
              MODELO DE NEGOCIO
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-560">
              Ganamos cuando tú ganas
            </h2>
            <div className="space-y-6" data-id="element-561">
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-562">
                <h3 className="font-bold text-[#0A1628] mb-3" data-id="element-563">
                  Comisión por colocación
                </h3>
                <p className="text-[#6B7280] mb-4" data-id="element-564">
                  Recibimos una comisión de las instituciones financieras cuando
                  un cliente cierra su crédito a través de nuestra plataforma.
                </p>
                <div className="flex items-center gap-4" data-id="element-565">
                  <div className="flex-1 bg-[#2B5FD9]/10 rounded-lg p-4" data-id="element-566">
                    <p className="text-xs text-[#6B7280] mb-1" data-id="element-567">
                      Ticket promedio
                    </p>
                    <p className="text-2xl font-bold text-[#2B5FD9]" data-id="element-568">
                      UF 3,000
                    </p>
                  </div>
                  <div className="flex-1 bg-[#2B5FD9]/10 rounded-lg p-4" data-id="element-569">
                    <p className="text-xs text-[#6B7280] mb-1" data-id="element-570">
                      Comisión estimada
                    </p>
                    <p className="text-2xl font-bold text-[#2B5FD9]" data-id="element-571">
                      0.5% - 1%
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-572">
                <h3 className="font-bold text-[#0A1628] mb-3" data-id="element-573">
                  100% gratis para el usuario
                </h3>
                <p className="text-[#6B7280]" data-id="element-574">
                  Los compradores no pagan nada. Las instituciones financieras
                  nos pagan por traerles clientes calificados.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 5: Tracción */}
        <section className="mb-16" data-id="element-575">
          <div className="bg-gradient-to-br from-yellow-50 to-amber-50 rounded-2xl p-8 md:p-12 border border-yellow-100" data-id="element-576">
            <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-700 text-xs font-semibold rounded-full mb-4" data-id="element-577">
              TRACCIÓN
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-578">
              Validación temprana del mercado
            </h2>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-579">
              <div className="bg-white rounded-xl p-6 shadow-sm text-center" data-id="element-580">
                <p className="text-4xl font-bold text-[#2B5FD9] mb-2" data-id="element-581">Beta</p>
                <p className="text-sm text-[#6B7280]" data-id="element-582">
                  Plataforma en desarrollo
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm text-center" data-id="element-583">
                <p className="text-4xl font-bold text-[#2B5FD9] mb-2" data-id="element-584">5+</p>
                <p className="text-sm text-[#6B7280]" data-id="element-585">
                  Instituciones financieras interesadas
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm text-center" data-id="element-586">
                <p className="text-4xl font-bold text-[#2B5FD9] mb-2" data-id="element-587">
                  Q1 2025
                </p>
                <p className="text-sm text-[#6B7280]" data-id="element-588">Lanzamiento objetivo</p>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 6: Equipo */}
        <section className="mb-16" data-id="element-589">
          <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-2xl p-8 md:p-12 border border-gray-200" data-id="element-590">
            <span className="inline-block px-3 py-1 bg-gray-200 text-gray-700 text-xs font-semibold rounded-full mb-4" data-id="element-591">
              EL EQUIPO
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-592">
              Experiencia en fintech y proptech
            </h2>
            <p className="text-lg text-[#6B7280] mb-8" data-id="element-593">
              Equipo con experiencia en tecnología financiera, bienes raíces y
              desarrollo de producto.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-594">
              <p className="text-[#6B7280]" data-id="element-595">
                Información del equipo disponible bajo NDA.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section data-id="element-596">
          <div className="bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-2xl p-8 md:p-12 text-center text-white" data-id="element-597">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-598">
              ¿Listo para revolucionar el mercado hipotecario?
            </h2>
            <p className="text-lg text-white/80 mb-8" data-id="element-599">
              Conversemos sobre cómo Creditual está transformando la experiencia
              de obtener un crédito hipotecario en Chile.
            </p>
            <a href="mailto:hola@creditual.com" className="inline-block px-8 py-4 bg-white text-[#2B5FD9] font-semibold rounded-xl hover:bg-gray-100 transition-colors shadow-lg" data-id="element-600">
              Contactar al equipo
            </a>
          </div>
        </section>
      </div>
    </div>;
}
export default PitchPage;